import {AuthModel} from './_models'

const AUTH_LOCAL_STORAGE_KEY = 'fds-auth-react-v'
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)

    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const auth = getAuth()
      if (auth && auth.access_token) {
        config.headers.Authorization = `Bearer ${auth.access_token}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  // v2 access tokens expire (8h, unlike the legacy never-expiring token): when
  // the backend answers 401, drop the stale auth and go back to the login
  // page — same behaviour as the main FDS app. Skipped while already on an
  // /auth page so a failed login shows its error instead of reloading.
  axios.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      const basePath = process.env.PUBLIC_URL || ''
      const onAuthPage = window.location.pathname.startsWith(`${basePath}/auth`)
      // ?sso= means an SSO exchange is in flight — a 401 here is the stale
      // stored token, and redirecting would drop the sso handoff token.
      // SingleSignOn handles its own failure path.
      const ssoInProgress = new URLSearchParams(window.location.search).has('sso')
      if (error?.response?.status === 401 && !onAuthPage && !ssoInProgress) {
        removeAuth()
        window.location.replace(`${basePath}/auth/login`)
      }
      return Promise.reject(error)
    }
  )
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY}
